export default __webpack_public_path__ + "assets/img/avatar-4.7874a64.png";